/**
 * @file DevModeSwitch.tsx
 * @description 개발자 모드 스위치 컴포넌트
 *
 * 개발 서버에서만 표시되는 개발자 모드 토글 스위치입니다.
 * 프로덕션 환경에서는 완전히 숨겨집니다.
 *
 * 사용 위치:
 * - 헤더 (테마 스위치 옆)
 */

"use client";

import { useDevMode } from "@/hooks/shared/use-dev-mode";
import { Button } from "@/components/shared/ui/button";
import { Code2, Code } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/shared/ui/tooltip";

export function DevModeSwitch() {
  const { isDevMode, toggleDevMode } = useDevMode();

  // 개발 서버에서만 표시 (프로덕션에서는 완전히 숨김)
  const isDevelopment = process.env.NODE_ENV === "development";
  
  if (!isDevelopment) {
    return null;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            variant={isDevMode ? "default" : "outline"}
            size="icon"
            onClick={toggleDevMode}
            aria-label="개발자 모드 토글"
            className={`relative z-10 ${isDevMode ? "bg-primary text-primary-foreground" : ""}`}
          >
            {isDevMode ? (
              <Code2 className="h-4 w-4" />
            ) : (
              <Code className="h-4 w-4" />
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>
            {isDevMode 
              ? "개발자 모드 활성화됨" 
              : "개발자 모드 비활성화됨"}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
